import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { ApiBaseUrl } from "../../http";
import { AppVersionFormData, IAppVersion } from './appVersion.type';

const AppVersionApi = createApi({
    reducerPath: "appVersionApi",
    tagTypes: ["appVersion"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${ApiBaseUrl}/api/`,
        prepareHeaders,
    }),
    endpoints: (build) => ({
        addAppVersion: build.mutation<IAppVersion, AppVersionFormData>({
            query: (data) => ({
                url: `app-version/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["appVersion"],
        }),
        getAppVersion: build.query<IAppVersion, void>({
            query: () => `app-version/`,
            providesTags: ["appVersion"],
        }),
    }),
});

export default AppVersionApi

export const {
    useAddAppVersionMutation,
    useGetAppVersionQuery,
} = AppVersionApi;
